import { render, staticRenderFns } from "./common_new.vue?vue&type=template&id=1784d9fd&scoped=true&"
import script from "./common_new.vue?vue&type=script&lang=ts&"
export * from "./common_new.vue?vue&type=script&lang=ts&"
import style0 from "./common_new.vue?vue&type=style&index=0&id=1784d9fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784d9fd",
  null
  
)

export default component.exports